import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const DemoPage: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [slowStart, setSlowStart] = useState(false);

  useEffect(() => {
    // After 6s show a "server warming up" message
    const slowTimer = setTimeout(() => setSlowStart(true), 6000);

    const autoLogin = async () => {
      try {
        const res = await fetch('/api/auth/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: 'demo@futbolero.com', password: 'demo123' }),
        });
        if (!res.ok) throw new Error('Login failed');
        const { token } = await res.json();
        localStorage.setItem('authToken', token);
        window.location.href = '/owner/reservations?demo=true';
      } catch {
        setError('No se pudo cargar la demo. El servidor no está disponible.');
      } finally {
        clearTimeout(slowTimer);
      }
    };
    autoLogin();

    return () => clearTimeout(slowTimer);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#181A1B',
      color: '#fff',
      fontFamily: "'Inter', sans-serif",
    }}>
      {error ? (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>⚠️</div>
          <p style={{ color: '#FF6B6B', fontSize: '16px', marginBottom: '24px' }}>{error}</p>
          <button
            onClick={() => navigate('/canchas')}
            style={{
              padding: '12px 24px',
              background: '#00E676',
              color: '#0A0A0A',
              border: 'none',
              borderRadius: '8px',
              fontWeight: 700,
              fontSize: '15px',
              cursor: 'pointer',
            }}
          >
            Volver al inicio
          </button>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '56px', marginBottom: '20px', animation: 'spin 1s linear infinite' }}>⚽</div>
          <p style={{
            fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
            fontSize: '28px',
            color: '#00E676',
            letterSpacing: '1px',
            margin: 0,
          }}>
            Cargando demo...
          </p>
          <p style={{ color: '#6B7280', fontSize: '14px', marginTop: '8px' }}>
            Preparando el panel de Complejo El Estadio
          </p>
          {slowStart && (
            <div style={{
              marginTop: '24px',
              padding: '12px 20px',
              background: '#1F2937',
              borderRadius: '8px',
              border: '1px solid #374151',
              maxWidth: '320px',
            }}>
              <p style={{ color: '#9CA3AF', fontSize: '13px', margin: 0, lineHeight: 1.5 }}>
                El servidor está iniciando — puede tardar hasta 30 segundos la primera vez.
                <br />
                <span style={{ color: '#6B7280', fontSize: '12px' }}>Es gratis, así que hiberna 😄</span>
              </p>
            </div>
          )}
        </div>
      )}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default DemoPage;
